import { createStore } from 'vuex'

import Profile from './modules/NavbarStore'
import RouteStore from './modules/RouteStore'

export default createStore({
    modules: {
        profile: Profile,
        route: RouteStore,
    }
})
